import { NgModule } from '@angular/core'
import { SharedModule } from '../shared/shared.module'
import { ContactanosComponent } from './contactanos/contactanos.component'
import { DashboardComponent } from './dashboard/dashboard.component'
import { HomeRoutingModule } from './home-routing.module'
import { HomeComponent } from './home/home.component'
import { FooterComponent } from './layout/footer/footer.component'
import { HeaderComponent } from './layout/header/header.component'
import { SidebarComponent } from './layout/sidebar/sidebar.component'

@NgModule({
  declarations: [
    HomeComponent,
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    DashboardComponent,
    ContactanosComponent,
  ],
  imports: [SharedModule, HomeRoutingModule],
})
export class HomeModule {}